var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PxStageStatusItem',{attrs:{"icon":_vm.icon,"title":_vm.title,"active":_vm.active,"icon-size":_vm.iconSize,"is-clickable":_vm.isClickable},on:{"status-click":function($event){_vm.isClickable ? _vm.$emit('status-click') : null}}})}
var staticRenderFns = []

export { render, staticRenderFns }